<template>
  <div
    class="wrapper"
    :class="{
      warning: hasWarning,
      caution: hasCaution,
      'default-bg': !hasWarning && !hasCaution,
    }"
  >
    <span>{{ name }}</span>
    <div class="info-icon-container" v-if="hasWarning || hasCaution">
      <vx-tooltip-with-slot-text position="bottom">
        <!-- ホバー時に表示するツールチップ -->
        <template v-slot:text>
          <tooltip-crew-assignment-alert :alerts="alertInfo" />
        </template>
        <!-- ホバー対象 -->
        <template v-slot:inner>
          <span
            class="material-icons alert-icon cursor-pointer"
            :class="{
              warning: hasWarning,
              caution: hasCaution,
            }"
          >
            error
          </span>
        </template>
      </vx-tooltip-with-slot-text>
    </div>
  </div>
</template>

<script>
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";
import { TooltipCrewAssignmentAlert } from "../../components/tooltips";

export default {
  name: "HeaderCellRendererVessel",
  components: { VxTooltipWithSlotText, TooltipCrewAssignmentAlert },
  computed: {
    name() {
      return this.params.name;
    },
    alertInfo() {
      return this.params.alertInfo || [];
    },
    hasCaution() {
      return (
        Array.isArray(this.alertInfo) &&
        this.alertInfo.some(info => info.alert_type === "CAUTION")
      );
    },
    hasWarning() {
      return (
        Array.isArray(this.alertInfo) &&
        this.alertInfo.some(info => info.alert_type === "WARNING")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";

.wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  padding: 18px 12px 18px 16px;
  gap: 16px;

  font-family: $aisea-font-family;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  vertical-align: middle;

  &.warning {
    background-color: #ffccc9;
  }
  &.caution {
    background-color: #fff8e3;
  }

  .info-icon-container {
    width: 14px;
    height: 14px;
    .alert-icon {
      font-size: 16px;
      &.warning {
        color: #e02e22;
      }
      &.caution {
        color: #ffd400;
      }
    }
  }
}
</style>
